// This category Id belongs to 'Bus'. These machines have a life expectancy
// of 20 years, so hopefully that's enough to perform the initial boundaries
// calculation without excluding too much machines.
export const DEFAULT_CATEGORY = '21'
export const DOWNPAYMENT_NEW = 0.15
export const DOWNPAYMENT_USED = 0.1
